import { Stack } from 'component-library';
import { Navigate, useParams } from 'react-router-dom';

import { INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE } from '@/api/rest/resources/types/IndicatorProduct';
import { BetaPill } from '@/components/Pill/BetaPill';
import { useGetIndicatorProductSubscriptionConfigurations } from '@/hooks/useDashboardIndicatorProductSubscriptionConfiguration';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { useDisplayInSituPages } from '@/pages/shared/uploads/hooks/useDisplayUploadsPage';
import { buildPath } from '@/utils/buildPath';

import { MediaMapItemCards } from './components/MediaMapItemCards';

export const MediaMapsConfigurationPage = () => {
  const menuItems = useMenuItems();
  const pathSet = usePathSet();
  const { configurationId } = useParams();

  const configurations =
    useGetIndicatorProductSubscriptionConfigurations(undefined, true, {
      type: INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.MEDIA_MAP,
    }).data?.results ?? [];

  const configuration = configurations.find((config) => config.id === configurationId);

  const { displayMediaMapPage } = useDisplayInSituPages();

  if (!displayMediaMapPage || !configuration) {
    return <Navigate to={pathSet.home} replace />;
  }

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: (
          <Stack direction='row' spacing={4} centerMain>
            {configuration.indicator_name} <BetaPill />
          </Stack>
        ),
        backPath: buildPath(pathSet.mediaMaps),
      }}
    >
      <Stack spacing={8} direction='row' className='flex-wrap w-full'>
        <MediaMapItemCards configuration={configuration} />
      </Stack>
    </SignedInPageLayout>
  );
};
